import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList, CartesianGrid } from "recharts";
import PropTypes from "prop-types";
import { COLORS } from "../constants";

export function VerticalBarChart({ data, colors, onBarClick }) {
  const palette = colors || COLORS;
  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 16, right: 8, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
        <XAxis dataKey="name" tick={{ fontSize: 11, fontWeight: 500 }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} allowDecimals={false} />
        <Tooltip
          contentStyle={{ borderRadius: 10, fontSize: 13 }}
          cursor={{ fill: "rgba(128,128,128,0.08)" }}
          formatter={v => [`${v} chargers`, ""]}
        />
        <Bar
          dataKey="value"
          radius={[6, 6, 0, 0]}
          animationDuration={800}
          animationEasing="ease-out"
          barSize={24}
          onClick={entry => onBarClick?.(entry)}
          style={onBarClick ? { cursor: "pointer" } : undefined}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={palette[i % palette.length]} />
          ))}
          <LabelList dataKey="value" position="top" style={{ fontSize: 11, fontWeight: 700, fill: "#475569" }} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

VerticalBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.number })).isRequired,
  colors: PropTypes.array,
  onBarClick: PropTypes.func,
};

export default VerticalBarChart;
